export default __webpack_public_path__ + "assets/icons/right-nav-back-top.21bfa636.svg";